import { render, staticRenderFns } from "./StatementComparison.vue?vue&type=template&id=53b88db2"
import script from "./StatementComparison.vue?vue&type=script&lang=js"
export * from "./StatementComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports